import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useFadeOutOnClickOutside } from "@hooks/useFadeOutOnClickOutside";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { Fade } from "reactstrap";
import Select from "../input/InputSelect";
import "@assets/css/components/dropdownSelect.css"

const BlackTooltip = withStyles(() => ({
  tooltip: {
    // maxWidth: "200px",
    backgroundColor: "#3F3F51",
    fontFamily: "Poppins_Medium",
    fontSize: "13px",
    padding: "8px 17px"
  }
}))(Tooltip);

export default function DropdownSimple(props) {
  const { t: filterTranslator } = useTranslation("components.filtre");
  const selectContainerRef = useRef();

  const { dropdownRef } = useFadeOutOnClickOutside({
    onClickOutside: props.mousEvents || props.selectEvent || null,
    fadeIn: props.fadeIn
  });

  const DropdownSelect = React.forwardRef((dropdownSelectProps, ref) => {
    return (
      <Select
        label={props.label}
        type="text"
        className={props.classSelect}
        onClick={props.selectEvent}
        value={props.valueNoTranslator ? props.selectValue : filterTranslator(props.selectValue)}
        placeholder={filterTranslator(props.selectText)}
        fadeIn={props.fadeIn}
        testId={props.testId}
        showResetFilter={props.showResetFilter}
        onResetFilter={props.onResetFilter}
        refs={ref}
      />
    );
  });

  const SelectContainer = React.forwardRef((containerProps, ref) => {
    if (props.customDiv) {
      return (
        <div className={props.customDiv} id={props.id} ref={ref}>
          <DropdownSelect />
        </div>
      );
    }

    return <DropdownSelect ref={ref} />;
  });

  return (
    <div className={props.className} ref={dropdownRef}>
      {props.withTooltip ? (
        <BlackTooltip title={props.selectValue} placement="top">
          <SelectContainer ref={selectContainerRef} />
        </BlackTooltip>
      ) : (
        <SelectContainer ref={selectContainerRef} />
      )}

      {props.MessageRequired}

      <Fade in={props.fadeIn} className={props.fadeClass}>
        <ul
          className={props.ulFullClass || "dropdown_select " + props.customUl}
        >
          {props.fadeIn ? (
            <>
              {props.inputLoupe}
              {props.MapDataLi}
              {props.button && (
                <button className="w-100 altee_btn altee_btn--green medium validate_btn">
                  {props.button}
                </button>
              )}
            </>
          ) : null}
        </ul>
      </Fade>
    </div>
  );
}
